// extracted by mini-css-extract-plugin
export default {"imgBox":"imgBox__imgBox-RPNp","img":"imgBox__img-MPO6"};